import { createGlobalState } from "@vueuse/core";
import { shallowReadonly, shallowRef } from "vue";

import type { UsePlayerReturn } from "@/composables/use-player.composable";

export const useAudioFocus = createGlobalState(() => {
  const focusedPlayer = shallowRef<UsePlayerReturn>();

  function claim(player: UsePlayerReturn) {
    const previousPlayer = focusedPlayer.value;

    // Pausing can synchronously start another player, so assign focus first.
    focusedPlayer.value = player;

    if (previousPlayer !== player) {
      previousPlayer?.pause();
    }
  }

  function release(player: UsePlayerReturn) {
    if (focusedPlayer.value === player) {
      focusedPlayer.value = undefined;
    }
  }

  return {
    focusedPlayer: shallowReadonly(focusedPlayer),
    claim,
    release,
  };
});
